import Swiper from 'swiper/bundle';

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {

    /**
     * Swiper Cards
     */
    if ( $('.cards_tour__list__slider').length > 0 ) {
      console.log('slider');
      let swiperCards = {};
      $('.cards_tour__list__slider').each(function (index) {
        let $this = $(this);
        $this.addClass('swiperCards-' + index);

        swiperCards[index] =  new Swiper('.swiperCards-' + index + ' .swiper-container', {
          autoHeight: true, //enable auto height
          slidesPerView         : 'auto',
          spaceBetween          : 12,
          slidesOffsetBefore    : 44,
          loop                  : false,
          speed                 : 500,
          observer              : true,
          observeParents        : true,
          observeSlideChildren  : true,
          pagination: {
            el          : '.swiperCards-' + index + ' .swiper-pagination',
            clickable   : true,
            type        : 'bullets',
          },
          navigation: {
            nextEl      : '.swiperCards-' + index + ' .swiper-button-next',
            prevEl      : '.swiperCards-' + index + ' .swiper-button-prev',
          },
        });

      });





    }

    /**
     * To Scroll
     * @click
     */
    $('.intro_tour__scroll').on('click', function (event) {
      event.preventDefault();

      var id  = $(this).attr('href'),
          header = $('.header_tour__inner').height(),
          top = parseInt($(id).offset().top - header);

      $('body,html').animate({scrollTop: top}, 900);
    });


  },
};



// WEBPACK FOOTER //
// ./scripts/routes/tour.js